import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { getCourse, getStudents, getLecturers, getAttendance } from '../services/api';

export default function CourseDetail() {
  const { id } = useParams<{ id: string }>();
  const { t, lang } = useLang();
  const [course, setCourse] = useState<any>(null);
  const [students, setStudents] = useState<any[]>([]);
  const [lecturer, setLecturer] = useState<any>(null);
  const [attendance, setAttendance] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState('info');

  useEffect(() => {
    if (!id) return;
    getCourse(id).then(res => {
      setCourse(res.data);
      if (res.data.lecturerId) {
        getLecturers().then(lr => {
          const l = lr.data.find((x: any) => x.id === res.data.lecturerId);
          setLecturer(l);
        });
      }
    }).catch(() => {});
    getStudents().then(res => setStudents(res.data)).catch(() => {});
    getAttendance({ courseId: id }).then(res => setAttendance(res.data)).catch(() => {});
  }, [id]);

  if (!course) return <div className="page-section"><p>{t('loading')}</p></div>;

  const days = [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday')];
  const enrolled = students.filter(s => course.enrolledStudents.includes(s.id));

  return (
    <div>
      <div className="page-section">
        <div className="page-title">
          <span className="page-title-text">
            📚 {lang === 'ar' && course.nameAr ? course.nameAr : course.name} ({course.code})
          </span>
          <Link to="/courses" className="btn btn-outline">← {t('back')}</Link>
        </div>

        <div className="tabs">
          <button className={`tab ${activeTab === 'info' ? 'active' : ''}`} onClick={() => setActiveTab('info')}>{t('details')}</button>
          <button className={`tab ${activeTab === 'students' ? 'active' : ''}`} onClick={() => setActiveTab('students')}>{t('students')}</button>
          <button className={`tab ${activeTab === 'attendance' ? 'active' : ''}`} onClick={() => setActiveTab('attendance')}>{t('attendance')}</button>
        </div>

        {activeTab === 'info' && (
          <div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">{t('courseName')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>{course.name}</div>
              </div>
              <div className="form-group">
                <label className="form-label">{t('courseCode')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>{course.code}</div>
              </div>
              <div className="form-group">
                <label className="form-label">{t('lecturer')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>
                  {lecturer ? `${lecturer.firstName} ${lecturer.lastName}` : course.lecturerId}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">{t('semester')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>{course.semester} - {course.year}</div>
              </div>
              <div className="form-group">
                <label className="form-label">{t('enrolled')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>{course.enrolledStudents.length}/{course.maxStudents}</div>
              </div>
              <div className="form-group">
                <label className="form-label">{t('price')}</label>
                <div className="form-input" style={{ background: '#f8f9fa' }}>{course.price.toLocaleString()} ₪</div>
              </div>
            </div>

            <h4 style={{ color: '#7B1FA2', marginTop: 20, marginBottom: 12 }}>{t('weeklySchedule')}</h4>
            <div className="table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>{t('day')}</th>
                  <th>שעת התחלה</th>
                  <th>שעת סיום</th>
                  <th>{t('room')}</th>
                </tr>
              </thead>
              <tbody>
                {course.schedule.map((s: any, i: number) => (
                  <tr key={i}>
                    <td>{days[s.day]}</td>
                    <td>{s.startTime}</td>
                    <td>{s.endTime}</td>
                    <td>{s.room}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {activeTab === 'students' && (
          <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>{t('name')}</th>
                <th>{t('email')}</th>
                <th>{t('phone')}</th>
                <th>{t('status')}</th>
              </tr>
            </thead>
            <tbody>
              {enrolled.map((s, i) => (
                <tr key={s.id}>
                  <td>{i + 1}</td>
                  <td><Link to={`/students/${s.id}`} style={{ color: '#7B1FA2', textDecoration: 'none' }}>{s.firstName} {s.lastName}</Link></td>
                  <td dir="ltr">{s.email}</td>
                  <td dir="ltr">{s.phone}</td>
                  <td><span className={`badge ${s.status === 'active' ? 'badge-green' : 'badge-gray'}`}>{s.status}</span></td>
                </tr>
              ))}
              {enrolled.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#999' }}>{t('noData')}</td></tr>}
            </tbody>
          </table>
          </div>
        )}

        {activeTab === 'attendance' && (
          <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>{t('name')}</th>
                <th>{t('date')}</th>
                <th>{t('status')}</th>
              </tr>
            </thead>
            <tbody>
              {attendance.map(a => {
                const s = students.find(st => st.id === a.studentId);
                return (
                  <tr key={a.id}>
                    <td>{s ? `${s.firstName} ${s.lastName}` : a.studentId}</td>
                    <td>{a.date}</td>
                    <td><span className={`badge ${a.status === 'present' ? 'badge-green' : 'badge-red'}`}>
                      {a.status === 'present' ? 'נוכח' : 'נעדר'}
                    </span></td>
                  </tr>
                );
              })}
              {attendance.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999' }}>{t('noData')}</td></tr>}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
}
